import { Link } from 'gatsby'
import PropTypes from 'prop-types'
import React from 'react'

const Header = ({ siteTitle }) => (
<section className="wrapper style1 align-center">
  <div className="blogheader">
    <div className="headerimage">
      <a href="javascript:history.back()"><i className="fa fa-arrow-left" aria-hidden="true"></i></a>
    </div>
    <div className="headertext">
      <a href="javascript:history.back()">Indietro</a>
    </div>
            {/* <img src="https://gion.si/static/images/profile.jpg" alt="Giovanni Gadaleta Image" className="img-circle"/> */}
    <div className="headerimage" style={{marginLeft:"15px",paddingLeft:"5px"}}>
      <Link
          to="/"
          style={{textDecoration:'none'}}
        >
        <i className="fa fa-home" aria-hidden="true"></i>
      </Link>
    </div>
    <div className="headertext">
      <Link to="/">Home</Link>
    </div>
  </div>
</section>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: '',
}

export default Header
